//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the matching flag. */
export const MatchFlag = {
    /** None */
    None: 0,

    /** Moved */
    Moved: 1,

    /** PO Box Closed */
    POBoxClosed: 2,

    /** Moved left no forwarding */
    MovedNoForwarding: 3,

    /** Moved to foreign country */
    MovedToForeignCountry: 4
} as const;

/** Represents the matching flag. */
export const MatchFlagDescription: Record<number, string> = {
    0: "None",

    1: "Moved",

    2: "PO Box Closed",

    3: "Moved No Forwarding",

    4: "Moved To Foreign Country"
};

/** Represents the matching flag. */
export type MatchFlag = typeof MatchFlag[keyof typeof MatchFlag];
